/**
 * Lead Details Page
 * =================
 * Dedicated page for viewing lead details
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui';
import { DashboardLayout } from '../../components/layout';
import { LeadDetails } from '../../components/leads';

const LeadDetailsPage = () => {
  const { leadId } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/leads');
  };

  const handleRefresh = () => {
    // Trigger refresh by re-rendering the component
    window.location.reload();
  };

  const handleScheduleMeeting = (leadId, leadName) => {
    navigate(`/leads/${leadId}/meetings`);
  };

  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="mb-3 flex items-center justify-between">
          <h1 className="text-[28px] font-sans font-bold text-gray-900 dark:text-white">
            Lead Details
          </h1>
          <Button variant="ghost" onClick={handleClose}>
            ← Back to List
          </Button>
        </div>

        {/* Lead Details */}
        <LeadDetails
          leadId={leadId}
          onClose={handleClose}
          onRefresh={handleRefresh}
          onScheduleMeeting={handleScheduleMeeting}
        />
      </div>
    </DashboardLayout>
  );
};

export default LeadDetailsPage;

